import axios from 'axios';
import { builderSurfaceJsonContentHeader } from '../../../common/utils/restApiHeaderUtils';
import {
  APP_SETTING_FETCH_DEV_API_KEYS_BEGIN,
  APP_SETTING_FETCH_DEV_API_KEYS_SUCCESS,
  APP_SETTING_FETCH_DEV_API_KEYS_FAILURE,
  APP_SETTING_FETCH_DEV_API_KEYS_DISMISS_ERROR,
} from './constants';

export function fetchDevApiKeys(args = {}) {
  const {
    projectId,
    version,
    environment,
    status,
    search,
    page = 1,
    limit = 10,
  } = args;
  return (dispatch) => {
    dispatch({
      type: APP_SETTING_FETCH_DEV_API_KEYS_BEGIN,
    });

    const header = builderSurfaceJsonContentHeader(projectId);
    const queryParams = [];
    if (environment && environment !== 'ALL') {
      queryParams.push(`environment=${encodeURIComponent(environment)}`);
    }
    if (status && status !== 'ALL') {
      queryParams.push(`status=${encodeURIComponent(status)}`);
    }
    if (search && typeof search === 'string' && search.trim()) {
      queryParams.push(`search=${encodeURIComponent(search.trim())}`);
    }
    if (page) {
      queryParams.push(`page=${encodeURIComponent(page)}`);
    }
    if (limit) {
      queryParams.push(`limit=${encodeURIComponent(limit)}`);
    }

    const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
    const url = `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/developer-apis/${projectId}/devApiKeys${queryString}`;

    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.get(url, header);
      doRequest.then(
        (res) => {
          dispatch({
            type: APP_SETTING_FETCH_DEV_API_KEYS_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: APP_SETTING_FETCH_DEV_API_KEYS_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissFetchDevApiKeysError() {
  return {
    type: APP_SETTING_FETCH_DEV_API_KEYS_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case APP_SETTING_FETCH_DEV_API_KEYS_BEGIN:
      return {
        ...state,
        fetchDevApiKeysPending: true,
        fetchDevApiKeysError: null,
      };

    case APP_SETTING_FETCH_DEV_API_KEYS_SUCCESS: {
      const isArray = Array.isArray(action.data);
      const keys = isArray ? action.data : (action.data && action.data.keys) || [];
      const totalCount = isArray
        ? keys.length
        : (action.data && typeof action.data.totalCount === 'number')
        ? action.data.totalCount
        : 0;
      const totalPages = isArray
        ? 1
        : (action.data && action.data.totalPages) || 1;
      const currentPage = isArray
        ? 1
        : (action.data && action.data.currentPage) || 1;
      const limit = isArray
        ? 10
        : (action.data && action.data.limit) || 10;
      const envCounts = isArray
        ? {}
        : (action.data && action.data.envCounts) || {};

      return {
        ...state,
        fetchDevApiKeysPending: false,
        fetchDevApiKeysError: null,
        devApiKeys: keys,
        devApiKeysTotalCount: totalCount,
        devApiKeysTotalPages: totalPages,
        devApiKeysCurrentPage: currentPage,
        devApiKeysLimit: limit,
        devApiKeysEnvCounts: envCounts,
      };
    }

    case APP_SETTING_FETCH_DEV_API_KEYS_FAILURE:
      return {
        ...state,
        fetchDevApiKeysPending: false,
        fetchDevApiKeysError: action.data.error,
      };

    case APP_SETTING_FETCH_DEV_API_KEYS_DISMISS_ERROR:
      return {
        ...state,
        fetchDevApiKeysError: null,
      };

    default:
      return state;
  }
}
